<template>
    <div class="ah-page padding">
        <div class="container">
            <div class="ah-panel padding">
                <div class="ah-setup-guide-message">
                    <div class="message">
                        <h1 class="title">啟用設定完成</h1>
                        <div style="margin: 50px 0 20px 0; color: #463cb2;">
                            <h3>{{ companyInfo.cmp }}<span v-if="isTrying">（試用）</span></h3>
                            <div v-if="isTrying">試用期間：{{ tryTimeRange }}</div>
                        </div>
                        <p>恭喜！您已完成系統啟用設定</p>
                    </div>
                </div>
                <div class="ah-setup-guide-button-action">
                    <el-button class="primary-action" :loading="isLoading" @click="$router.push({ name: 'setup-audit' })">
                        回上一步
                    </el-button>
                    <el-button type="primary" class="primary-action" :loading="isLoading" @click="onClick">
                        完成
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
    data() {
        return {
            isLoading: false,
        };
    },
    computed: {
        ...mapGetters({
            companyInfo: 'menu/memberInfo',
            isTrying: 'menu/isTrying',
        }),
        tryTimeRange() {
            const SDT = moment(this.companyInfo.sdt).format('YYYY/MM/DD');
            const EDT = moment(this.companyInfo.edt).format('YYYY/MM/DD');
            return `${SDT} ~ ${EDT}`;
        },
    },
    methods: {
        async onClick() {
            try {
                this.isLoading = true;
                await this.$api({
                    url: 'Tool/ResetAccountRecords',
                    method: 'GET',
                });
                await this.$api({
                    url: '/CompanyInfoManagentPage/SetCompanyInitStatus',
                    method: 'POST',
                    data: {
                        initStatus: 1,
                    },
                });

                this.$message({
                    showClose: true,
                    message: '已完成啟用設定！',
                    type: 'success',
                });

                await this.$store.dispatch('menu/updateMenu');
                this.$router.push({ name: 'index' });
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>
